import React from "react";
import { DishGroup } from "./cookingDataUtils";

export function DishTagSelector({
  dishGroups,
  activeIndex,
  onSelect,
}: {
  dishGroups: DishGroup[];
  activeIndex: number;
  onSelect: (index: number) => void;
}) {
  if (dishGroups.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {dishGroups.map((dish, idx) => (
        <button
          key={dish.keyString}
          onClick={() => onSelect(idx)}
          className={`px-3 py-1.5 rounded-full text-sm font-semibold border transition-colors ${
            idx === activeIndex
              ? "text-gold border-gold border-[1.5px]"
              : "bg-transparent text-ink border-line hover:bg-surface-raised"
          }`}
        >
          {dish.description}
        </button>
      ))}
    </div>
  );
}
